import { Route, Routes } from 'react-router-dom'
import { TableAnalysisProjects } from './table/table'


export const BrowserAnalysisProjects = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableAnalysisProjects />} />
        </Routes>
    )
}